import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M13.6666 2.33203H2.33325V4.9987L6.33325 9.66536V14.332L9.66659 12.9987V9.66536L13.6666 4.9987V2.33203Z",
      stroke: "#7F7F83"
    }, null, -1)
  ])))
}
export default { render: render }